<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus">
      <div slot="info">
        <!--<h4>
          <span>销毁单号:</span>
          <span>{{id}}</span>
        </h4>-->
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="销毁单信息">
            <lk-form :label-width="134">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="销毁时间:">
                    <span>{{destroyTime}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="23">
                  <lk-form-item label="销毁商品:">
                    <lk-table border :columns="columns" :data="tableData"></lk-table>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';

export default {
  name: 'destroyFlow',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '销毁报废审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      columns: [
        {
          title: '商品编码',
          key: 'goodsInfoVoDrugSerialCode',
          minWidth: 110,
        },
        {
          title: '商品类型',
          key: 'goodsInfoVoTypeName',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'goodsInfoVoApprovedDrugName',
          minWidth: 110,
        },
        {
          title: '商品名称',
          key: 'goodsInfoVoGoodsName',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'goodsInfoVoSpec',
          minWidth: 110,
        },
        {
          title: '批准文号/注册证号',
          key: 'goodsInfoVoApprovalCode',
          minWidth: 146,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'goodsInfoVoDosageFormName',
          minWidth: 110,
        },
        {
          title: '单位',
          key: 'inventoryInfoDrugMiniPackageUnit',
          minWidth: 110,
        },
        {
          title: '生产企业',
          key: 'goodsInfoVoProducer',
          minWidth: 110,
        },
        {
          title: '产地',
          key: 'goodsInfoVoCountryOfOrigin',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'inventoryInfoWarehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'inventoryInfoLocationCode',
          minWidth: 150,
        },
        {
          title: '批次',
          key: 'inventoryInfoGoodsBatchSeq',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'inventoryInfoGoodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '数量',
          key: 'num',
          minWidth: 60,
        },
        {
          title: '销毁原因',
          key: 'reason',
          fixed: 'right',
          minWidth: 130,
        },
      ],
      tableData: [],
      destroyTime: '',
    };
  },
  methods: {
    getDestroyInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const {
          code,
          destroyTime,
          createUserName,
          createTime,
          destroyGoodsVoList,
        } = res.data.data;
        destroyGoodsVoList.forEach((item) => {
          const result = {};
          utils.exchangeTable(item, result);
          this.tableData.push(result);
        });
        this.destroyTime = utils.formatDate(destroyTime);
        this.infosArr.push({
          name: '销毁单号',
          value: code,
        }, {
          name: '销毁时间',
          value: utils.formatDate(destroyTime),
        }, {
          name: '创建人',
          value: createUserName,
        }, {
          name: '创建时间',
          value: utils.formatTime(createTime),
        });
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getDestroyInfo(this.approvalParams.businessUrl);
  },
};
</script>
